<template>
    <div class="offering">
        <div v-if="isLoading" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.8); display: flex; align-items: center; justify-content: center; z-index: 9999;">
            <div style="text-align: center;">
                <div style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #6089E7; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto;"></div>
                <p style="margin-top: 20px; color: #6089E7;">Loading...</p>
            </div>
        </div>
        <div
                class="offering-page"
                :style="{ pointerEvents: isLoading ? 'none' : 'auto', opacity: isLoading ? 0.5 : 1 }"
        >
            <VHeader :page="!isEditMode ? 'Offerings': 'Edit Offering'"></VHeader>
            <div
                    class="offering-page-wrapper"
                    v-if="!isEditMode"
            >
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Application
                </div>
                <VSelect
                        v-model="project"
                        :class="{'offering-page-wrapper_error' : isApplicationEmpty}"
                        :options="projects"
                        :show-property="'title'"
                        :icon-property="'logo_small'"
                        :with-search="true"
                        search-placeholder="Search applications..."
                        :search-fields="['title', 'bundle_id']"
                >
                    <VButton
                    >
                        <img
                                v-if="project.title"
                                :src="project.logo_small"
                                alt="Painting"
                        >
                        {{ project.title || 'choose application' }}
                    </VButton>
                </VSelect>
            </div>
            <div class="offering-page-separator"></div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper-section">
                    <p>Products</p>
                </div>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Id
                </div>
                <VInput
                        v-model="newPackage.id"
                        placeholder='id'
                        :class="{'offering-page-wrapper_error' : isPackageIdEmpty}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Description
                </div>
                <VInput
                        v-model="newPackage.description"
                        placeholder='description'
                        :class="{'offering-page-wrapper_error' : isPackageDescriptionEmpty}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Product id
                </div>
                <VInput
                        v-model="newPackage.product_id"
                        placeholder='product id'
                        :class="{'offering-page-wrapper_error' : isPackageProductIdEmpty}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Arppu value
                </div>
                <VInput
                        v-if="newPackage.arppu"
                        v-model="newPackage.arppu"
                        placeholder='value'
                        :min="0"
                        :is-allow-fractional="true"
                        type="number"
                        :class="{'offering-page-wrapper_error' : isPackageArppuEmpty}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Purchase type
                </div>
                <VSelectPrimitiveCombobox
                        v-model="newPackage.purchase_type"
                        :class="{'offering-page-wrapper_error' : isPurchaseTypeEmpty}"
                        :options="purchaseTypes"
                >
                    <VButton
                    >
                        {{ newPackage.purchase_type || 'Purchase type' }}
                    </VButton>
                </VSelectPrimitiveCombobox>
            </div>
            <div class="offering-page-wrapper offering-page-wrapper__button">
                <VButton
                        @click="addPackage"
                        :type="'button'"
                        theme="positive"
                >Add package
                </VButton>
            </div>

            <div class="offering-page-table offering-page-table__length highlighted-table">
                <template>
                    <div class="offering-page-table-header">
                        <div
                                class="offering-page-table-header-title offering-page-table-header-title__length"
                                v-for="(columnTitle, columnName) in tablePackage"
                                :key="columnName"
                                :style="columnTitle.trim() === 'product' ? { width: '30%', minWidth: '30%' } : {}"
                        >
                             <span
                                     v-if="filterValue.name === columnName"
                                     class="filter-icon"
                             >
                                <span
                                        :class="{'filter-triangle-icon_descending': filterValue.direction==='descending'}"
                                        class="filter-triangle-icon"
                                >
                                </span>
                            </span>
                            {{ columnTitle }}
                        </div>
                    </div>
                    <div
                            class="offering-page-table-row "
                            v-for="(packagePage, packagePageIndex) in newOffering.packages"
                            :key="packagePage.name"

                    >
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length"
                        >
                            {{ packagePage.id }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length "
                        >
                            {{ packagePage.description }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length"
                                style="min-width: 30%;"
                        >
                            {{ packagePage.product_id }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length"
                        >
                            {{ packagePage.purchase_type }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length"
                        >
                            {{ packagePage.arppu }}
                        </div>
                        <div class="offering-page-table-row-close-position">
                            <div
                                    class="offering-page-table-row-close-position-icon"
                                    @click="showDeletePackageNotification(packagePageIndex)"
                            >
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="offering-page-separator"></div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper-section">
                    <p>Offerings</p>
                </div>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Id
                </div>
                <VInput
                        :class="{'offering-page-wrapper_error' : isOfferingIdEmpty}"
                        v-model="newOffering.id"
                        placeholder='id'
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Description
                </div>
                <VInput
                        :class="{'offering-page-wrapper_error' : isOfferingDescriptionEmpty}"
                        v-model="newOffering.description"
                        placeholder='description'
                ></VInput>
            </div>
            <div class="offering-page-wrapper offering-page-wrapper__button ">
                <div class="offering-page-wrapper-buttons">
                    <template
                            v-if="isEditMode"
                    >
                        <VButton
                                @click="cancel"
                                :type="'button'"
                                theme="positive"
                        >Cancel
                        </VButton>
                        <div class="offering-page-wrapper__button-width">
                            <VButton
                                    @click="showSaveNotification"
                                    :type="'button'"
                                    theme="positive"
                            >Save
                            </VButton>
                        </div>
                    </template>
                    <template v-else>
                        <VButton
                                @click="addOffering"
                                :type="'button'"
                                theme="positive"
                        >Add offering
                        </VButton>
                    </template>
                </div>
            </div>


            <div class="offering-page-separator"></div>
            <div
                    class="offering-page-table highlighted-table"
                    v-if="!isEditMode"
            >
                <template>

                    <div
                            class="offering-page-table-header"

                    >
                        <div
                                class="offering-page-table-header-title"
                                v-for="(columnTitle, columnName) in table"
                                :key="columnName"
                        >
                             <span
                                     v-if="filterValue.name === columnName"
                                     class="filter-icon"
                             >
                                <span
                                        :class="{'filter-triangle-icon_descending': filterValue.direction==='descending'}"
                                        class="filter-triangle-icon"
                                >
                                </span>
                            </span>
                            {{ columnTitle }}
                        </div>
                    </div>
                    <div
                            class="offering-page-table-row "
                            v-for="(offeringPage, offeringPageIndex) in offerings"
                            :key="offeringPage.name"

                    >
                        <div
                                class="offering-page-table-row-text "
                        >
                            {{ offeringPage.id }}
                        </div>
                        <div class="offering-page-table-row-text ">
                            {{ offeringPage.description }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text_click"
                        >
                            {{ offeringPage.packages.length }}
                        </div>
                        <div
                                class="offering-page-table-row-close-position offering-page-table-row-close-position__save"
                                @click="edit(offeringPage,offeringPageIndex)"
                        >
                            <div>
                                Edit
                            </div>
                        </div>
                        <div class="offering-page-table-row-close-position">
                            <div
                                    class="offering-page-table-row-close-position-icon"
                                    @click="showDeleteOfferingNotification(offeringPageIndex)"
                            >
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="offering-page-separator"></div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper-section">
                    <p>ARPPU</p>
                </div>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Arppu name
                </div>
                <VInput
                        v-model="newArppu.name"
                        placeholder='name'
                        :class="{'offering-page-wrapper_error' : isArppuActivated && !newArppu.name.length}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper">
                <div class="offering-page-wrapper_title offering-page-wrapper_text">
                    Arppu value
                </div>
                <VInput
                        v-model="newArppu.value"
                        placeholder='value'
                        :min="0"
                        :is-allow-fractional="true"
                        type="number"
                        :class="{'offering-page-wrapper_error' : isArppuActivated && !newArppu.value.length}"
                ></VInput>
            </div>
            <div class="offering-page-wrapper offering-page-wrapper__button">
                <VButton
                        @click="addArppu(newArppu.name,newArppu.value,project ? project.bundle_id:null)"
                        :type="'button'"
                        theme="positive"
                >Add arppu
                </VButton>
            </div>
            <div class="offering-page-table highlighted-table">
                <template>
                    <div class="offering-page-table-header">
                        <div
                                class="offering-page-table-header-title offering-page-table-header-title__length"
                                v-for="(columnTitle, columnName) in tableArppuNames"
                                :key="columnName"
                        >
                             <span
                                     v-if="filterValue.name === columnName"
                                     class="filter-icon"
                             >
                                <span
                                        :class="{'filter-triangle-icon_descending': filterValue.direction==='descending'}"
                                        class="filter-triangle-icon"
                                >
                                </span>
                            </span>
                            {{ columnTitle }}
                        </div>
                    </div>
                    <div
                            class="offering-page-table-row "
                            v-for="(arppu, arppuIndex) in currentArppuArray"
                            :key="arppuIndex"
                    >
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length"
                        >
                            {{ arppu.name }}
                        </div>
                        <div
                                class="offering-page-table-row-text offering-page-table-row-text__length "
                        >
                            {{ arppu.value }}
                        </div>
                        <div
                                class="offering-page-table-row-close-position offering-page-table-row-close-position__save"
                                @click="editArppu(arppu)"
                        >
                            <div>
                                Edit
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import VInput from '../components/VInput';
    import VSelect from '../components/VSelect';
    import VSelectPrimitiveCombobox from '../components/VSelectPrimitiveCombobox';
    import {getBoards, getProjects, getEventsWithData} from '../api/apiServices';
    import apiOfferings from '../api/apiOfferings';
    import apiFeatures from '../api/apiFeatures';
    import {eventBus} from '../main';

    export default {
        name: 'Offerings',
        components: {
            VInput,
            VSelect,
            VSelectPrimitiveCombobox,
        },
        data() {
            return {
                isApplicationEmpty: false,
                isOfferingIdEmpty: false,
                isOfferingDescriptionEmpty: false,
                isPurchaseTypeEmpty: false,
                isPackageProductIdEmpty: false,
                isPackageIdEmpty: false,
                isArppuActivated: false,
                isPackageDescriptionEmpty: false,
                isPackageArppuEmpty: false,
                isLoading: false,
                projects: getProjects(),
                project: {},
                newOffering: {},
                newArppu: {
                    name: '',
                    value: '0',
                },
                offerings: [],
                purchaseTypes: ['weekly', 'monthly', 'yearly', 'consumable', 'non-consumable'],
                emptyOffering: Object.freeze({
                    packages: [],
                    id: '',
                    description: '',
                }),
                emptyPackage: Object.freeze({
                    id: '',
                    description: '',
                    product_id: '',
                    purchase_type: '',
                    arppu: '',
                    // products: [],
                }),
                newPackage: {},
                // newProduct: '',
                filterValue: {
                    name: null,
                    direction: null,
                },
                tablePackage: {
                    id: 'id',
                    description: 'description',
                    product: 'product',
                    purchase_type: 'Purchase type',
                    arppu: 'Arppu value',
                    '': '',
                    // ' ': '',
                },
                tableArppuNames: {
                    name: 'name',
                    value: 'value',
                    '': '',
                },
                table: {
                    id: 'Offering Id',
                    description: 'Offering description',
                    packages: 'Packages',
                    '': '',
                },
                currentOffering: null,
                isEditMode: false,
                editIndex: null,
                allArppus: {},
                currentArppu: {},

            };
        },
        watch: {
            'project': {
                async handler(newProject) {
                    if (!newProject.bundle_id) return;
                    this.isLoading = true;
                    await this.getCurrentArppu();
                    apiOfferings.getOfferings(newProject.bundle_id).then((response) => {
                        const filteredOffering = _.cloneDeep(response.data);
                        filteredOffering.forEach((offering) => {
                            offering.packages.forEach((p) => {
                                if (this.currentArppu[p.product_id]) {
                                    p.arppu = this.currentArppu[p.product_id];
                                }
                            });
                        });
                        this.offerings = filteredOffering;
                        this.isLoading = false;
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Api request error : ${error.response.data.error}`,
                            );
                        }
                        this.isLoading = false;
                    });

                },
            },
            'newPackage.product_id': {
                async handler(newProductId) {
                    if (this.currentArppu && this.currentArppu[newProductId] !== null) {
                        this.newPackage.arppu = this.currentArppu[newProductId];
                    }
                    console.log('newProductId', _.cloneDeep(newProductId));

                },
            },
        },
        computed: {
            currentArppuArray() {
                let result = [];
                for (let key in this.currentArppu) {
                    if (Object.prototype.hasOwnProperty.call(this.currentArppu, key)) {
                        result.push({name: key, value: this.currentArppu[key]});
                    }
                }
                return result;
            },
        },
        created() {
            this.init();
            eventBus.$on('VNotification-Save', this.save);
            eventBus.$on('VNotification-delete-offering', this.deleteOffering);
            eventBus.$on('VNotification-delete-package', this.deletePackage);
        },
        beforeDestroy() {
            eventBus.$off('VNotification-Save', this.save);
            eventBus.$off('VNotification-delete-offering', this.deleteOffering);
            eventBus.$off('VNotification-delete-package', this.deletePackage);
        },
        methods: {
            init() {
                this.newOffering = _.cloneDeep(this.emptyOffering);
                this.newPackage = _.cloneDeep(this.emptyPackage);
            },
            edit(offering, index) {
                this.editIndex = index;
                this.isEditMode = true;
                this.newOffering = _.cloneDeep(offering);
            },
            editArppu(arppu) {
                console.log('arppu', _.cloneDeep(arppu));
                this.newArppu = _.cloneDeep(arppu);
            },
            save() {
                this.isEditMode = false;
                if (this.newOffering.id && this.newOffering.description) {
                    this.offerings.splice(this.editIndex, 1, _.cloneDeep(this.newOffering));
                    this.newOffering = _.cloneDeep(this.emptyOffering);
                    this.$toastr.s('Saved');
                    this.newOffering.packages.forEach((p) => {
                        if (p.arppu) {
                            this.addArppu(p.product_id, p.arppu, this.project.bundle_id);
                        }
                    });
                    apiOfferings.addOfferings(this.project.bundle_id, this.offerings).then(() => {
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Api request error : ${error.response.data.error}`,
                            );
                        }
                    });
                }
            },
            cancel() {
                this.isEditMode = false;
                this.newOffering = _.cloneDeep(this.emptyOffering);
            },
            showSaveNotification() {
                const notification = {};
                notification.confirmText = 'Save';
                notification.eventConfirm = 'VNotification-Save';
                notification.contentText = '';
                notification.headerText = `Are you sure want to save?`;
                eventBus.$emit('VNotificationShow', notification);
            },
            showDeleteOfferingNotification(index) {
                const notification = {};
                notification.confirmText = 'Delete';
                notification.data = index;
                notification.eventConfirm = 'VNotification-delete-offering';
                notification.contentText = '';
                notification.headerText = `Are you sure want to delete?`;
                eventBus.$emit('VNotificationShow', notification);
            },
            showDeletePackageNotification(index) {
                const notification = {};
                notification.confirmText = 'Delete';
                notification.data = index;
                notification.eventConfirm = 'VNotification-delete-package';
                notification.contentText = '';
                notification.headerText = `Are you sure want to delete?`;
                eventBus.$emit('VNotificationShow', notification);
            },
            addArppu(arpName, arpVal, projectBundleId) {
                const sendObj = {};
                if (arpName && arpVal && projectBundleId) {
                    sendObj[arpName] = +arpVal;
                    apiFeatures.addArppus(projectBundleId, sendObj).then(() => {
                        this.isArppuActivated = false;

                        this.isApplicationEmpty = false;

                        this.$set(this.currentArppu, arpName, arpVal);
                        this.newArppu = {
                            name: '',
                            value: '0',
                        };
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Api request error : ${error.response.data.error}`,
                            );
                        }
                    });
                } else {
                    if (!arpName || !arpVal) {
                        this.isArppuActivated = true;
                    }
                    if (!projectBundleId) {
                        this.isApplicationEmpty = true;
                    }
                }
            },
            async getCurrentArppu() {
                console.log('this.project', _.cloneDeep(this.project));
                const boardWithSavedBoardId = getBoards()[0];
                const featuresWithBundleId = boardWithSavedBoardId.features;
                // events: getEventsWithData().map((e) => e.name),
                const sendObj = {
                    events: getEventsWithData().map((e) => e.name),
                    features: ['bundle_id'].concat(featuresWithBundleId.map((e) => e.name)),
                    filter: {
                        date: {
                            end: boardWithSavedBoardId.datePeriod.end,
                            start: boardWithSavedBoardId.datePeriod.start,
                            cohort: boardWithSavedBoardId.cohort,
                        },
                        additional: `&equal:bundle_id=${this.project.bundle_id}`,
                    },
                    sandbox: boardWithSavedBoardId.sandbox,
                };

                return apiFeatures.getArppus(sendObj, {}).then((response) => {
                    let data = {};
                    const oldData = _.cloneDeep(response.data);
                    for (let key in oldData) {
                        if (typeof oldData[key] === 'number') {
                            data[key] = oldData[key].toString();
                        }
                    }
                    this.currentArppu = data;
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Get arppu request error : ${error.response.data.error}`,
                        );
                    }
                });
            },
            addOffering() {
                this.isApplicationEmpty = false;
                this.isOfferingIdEmpty = false;
                this.isOfferingDescriptionEmpty = false;
                this.isPurchaseTypeEmpty = false;
                this.isPackageProductIdEmpty = false;
                this.isPackageIdEmpty = false;
                this.isPackageDescriptionEmpty = false;
                this.isPackageArppuEmpty = false;
                if (!this.newOffering.id) {
                    this.$toastr.longError('Id can\'t be empty');
                    this.isOfferingIdEmpty = true;
                }
                if (!this.project.title) {
                    this.$toastr.longError('Application can\'t be empty');
                    this.isApplicationEmpty = true;
                }
                if (!this.newOffering.description) {
                    this.$toastr.longError('Description can\'t be empty');
                    this.isOfferingDescriptionEmpty = true;
                }
                if (!this.newOffering.packages.length) {
                    this.$toastr.longError('Packages can\'t be empty');
                    this.isPackageIdEmpty = true;
                    this.isPackageDescriptionEmpty = true;
                }
                if (this.newOffering.id && this.newOffering.description && this.newOffering.packages &&
                    this.project.title && this.newOffering.packages.length) {
                    this.newOffering.packages.forEach((p) => {
                        if (p.arppu) {
                            this.addArppu(p.product_id, p.arppu, this.project.bundle_id);
                        }
                    });
                    this.offerings.push(this.newOffering);
                    console.log('this.newOffering', _.cloneDeep(this.newOffering));

                    this.newOffering = _.cloneDeep(this.emptyOffering);
                    apiOfferings.addOfferings(this.project.bundle_id, this.offerings).then(() => {
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Api request error : ${error.response.data.error}`,
                            );
                        }
                    });
                }
            },
            addPackage() {
                if (!this.newPackage.id) {
                    this.$toastr.longError('Package id can\'t be empty');
                    this.isPackageIdEmpty = true;
                }
                if (!this.newPackage.description) {
                    this.$toastr.longError('Package description can\'t be empty');
                    this.isPackageDescriptionEmpty = true;
                }
                if (!this.newPackage.product_id) {
                    this.$toastr.longError('Product id can\'t be empty');
                    this.isPackageProductIdEmpty = true;
                }
                if (!this.newPackage.purchase_type) {
                    this.$toastr.longError('Purchase type can\'t be empty');
                    this.isPurchaseTypeEmpty = true;
                }
                // if (!this.newPackage.arppu) {
                //     this.$toastr.longError('Arppu can\'t be empty');
                //     this.isPackageArppuEmpty = true;
                // }
                // if (this.newPackage.id && this.newPackage.description && this.newPackage.product_id && this.newPackage.arppu) {
                if (this.newPackage.id && this.newPackage.description && this.newPackage.product_id) {
                    this.isPackageProductIdEmpty = false;
                    this.isPackageIdEmpty = false;
                    this.isPackageDescriptionEmpty = false;
                    this.isPurchaseTypeEmpty = false;
                    this.isPackageArppuEmpty = false;
                    this.newOffering.packages.push(this.newPackage);
                    this.newPackage = _.cloneDeep(this.emptyPackage);
                }
            },

            deleteOffering(offeringPageIndex) {
                this.offerings.splice(offeringPageIndex, 1);
                apiOfferings.addOfferings(this.project.bundle_id, this.offerings).then(() => {
                    this.$toastr.s('Deleted');
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Api request error : ${error.response.data.error}`,
                        );
                    }
                });
            },
            deletePackage(packagePageIndex) {
                this.newOffering.packages.splice(packagePageIndex, 1);
            },
        },
    };
</script>

<style lang="scss">
  .offering-page-table-header {

    display: flex;
    height: 53px;
    border-bottom: 1px solid #6089E7;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
<style
    lang="scss"
    scoped
>
  .offering {
    &-page {
      &-wrapper {
        display: flex;
        width: 228px;
        margin-left: 10px;
        margin-top: 5px;

        ::v-deep {
          .VButton {
            width: 296px;

            .VButton__title {
              display: flex;
              align-items: center;
              margin-right: 20px;

              img {
                width: 14px;
                height: 14px;
                margin-right: 20px;
              }
            }
          }
        }

        ::v-deep {

          .VSelect-dropdown__li {
            display: flex;
            align-items: center;

            img {
              width: 25px;
              height: 25px;
              margin-right: 20px;
            }
          }

        }

        &-section {
          font-family: Poppins;
          height: 12px;
          color: #000F48;
          font-size: 24px;
          letter-spacing: 0;
          line-height: 22px;
          margin: 0 0 12px 200px;
        }

        &_title {
          display: flex;
          min-width: 100px;
          align-items: center;
          padding-top: 5px;
        }

        &_text {
          color: red;
        }

        &-buttons {
          display: flex;
          justify-content: space-between;
          width: 255px;
        }

      }

      ::v-deep {
        input {
          width: 300px;
        }
      }

      &-wrapper__button {
        display: flex;
        margin-top: 15px;
        margin-left: 205px;

        ::v-deep {
          .VButton {
            width: 88px;
            margin-right: 15px;

            &__title {
              margin-left: 20px;
            }
          }
        }
      }

      &-wrapper__button-width {
        ::v-deep {
          .VButton {
            width: 50px;
          }
        }
      }

      .offering-page-wrapper_error {
        ::v-deep {
          input {
            border-color: red;
          }
        }

        ::v-deep {
          .VButton {
            border-color: red;
          }
        }
      }

      &-table {
        border-radius: 10px;
        @include dark-shadow;
        max-width: 100%;
        margin: 26px;

        &-header {


          &-title {
            display: flex;
            justify-content: center;
            padding: 17px;
            margin-top: 13px;
            font-family: Poppins;
            height: 12px;
            color: #000F48;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 12px;
            width: 31%;
            cursor: pointer;

            &:last-child {
              width: 97px;
              padding: 0;

            }
          }

          &-title__length {
            width: 15%;
          }

          &-title_package {
            width: calc(100% - 78px);
          }
        }

        &-row {
          display: flex;
          min-height: 45px;
          border-top: 1px solid rgba(96, 137, 231, 0.2);

          &-text {
            display: flex;
            justify-content: center;
            font-family: Quicksand;
            word-break: break-word;
            padding: 17px;
            color: #000F48;
            font-size: 14px;
            letter-spacing: 0;
            width: 31%;
            text-align: center;
            align-items: center;
            gap: 10px;

            img {
              width: 30px;
            }

            @media (max-width: 927px) {
              font-size: 12px;
            }

            &_package {
              width: calc(100% - 48px);
            }

          }

          &-text__length {
            width: 15%;
          }

          &-text_click {
            cursor: pointer;
          }

          &-close-position {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 97px;

            &-icon {
              padding: 10px;
              width: 10px;
              background-repeat: no-repeat;
              background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
              cursor: pointer;
            }
          }

          &-close-position__save {
            margin: 11px 0 0 0;
            border: 1px solid $primary-color;
            border-radius: 5px;
            height: 25px;
            font-size: 16px;
            line-height: 20px;
            align-items: center;
            text-align: center;
            color: $secondary-color;
            justify-content: center;
            cursor: pointer;
          }

        }

        //&-row:hover {
        //    background: #e0eef6;
        //}
      }

      &-table__length {
        //margin: -115px 0 75px 445px;
      }

      &-table__first-length {
        width: 21%;
        margin: -80px 0 38px 445px;
      }

      &-separator {
        display: flex;
        width: 424px;
        height: 3px;
        background: green;
        margin: 10px 0 10px 0;
      }
    }

    .filter-icon {
      position: relative;
      height: 5px;
      width: 3px;
      display: inline-block;
    }

    .filter-triangle-icon {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 2.5px 5px 2.5px;
      border-color: transparent transparent #00cd96 transparent;
      position: absolute;
      right: 2px;
      top: 5px;

      &_descending {
        transform: rotate(180deg);
      }
    }
  }
</style>
